import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import * as React from 'react'
import { useEffect, useState } from 'react'

// https://tanstack.com/query/v4/docs/devtools#devtools-in-production
const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/lib/index.prod.js').then((d) => ({
    default: d.ReactQueryDevtools,
  }))
)

const QueryDevtools: React.FC = () => {
  const [showDevtools, setShowDevtools] = useState(false)

  useEffect(() => {
    window.toggleDevtools = () => setShowDevtools((old) => !old)
  }, [])

  return (
    <>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      {showDevtools ? (
        <React.Suspense fallback={null}>
          <ReactQueryDevtoolsProduction />
        </React.Suspense>
      ) : null}
    </>
  )
}

export default QueryDevtools
